import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/rfSubProcessOption/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/rfSubProcessOption/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/rfSubProcessOption/findPage',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/rfSubProcessOption.js